import React from 'react';
import { Box } from '@mui/material';
import CheckCircle from '@mui/icons-material/CheckCircle';
import Circle from '@mui/icons-material/Circle';
import ErrorOutlineOutlined from '@mui/icons-material/ErrorOutlineOutlined';
import CircleOutlined from '@mui/icons-material/CircleOutlined';
import { toArray } from 'src/util/Util';
import { formatMessage, getScreenData, Store, setScreenData, ACTIVE_SCREEN_KEY } from 'cw-ui-core';
import Locale from 'src/i18n';

export const stepModes = {
    NEXT: 'next',
    SUBMIT_WITH_SUCCESS_SCREEN: 'submit_with_success_screen',
    SUBMIT_AND_CLOSE: 'submit_and_close',
    CLOSE: 'close',
};

// use this method for setting the error state of a specific step
// you can use it in service methods as well to indicate bad API requests
export const setErrorByIndex = (stepIndex, isError = false, path = 'errors', screenKey = ACTIVE_SCREEN_KEY) => {
    const errors = toArray(getScreenData(Store().getState().screen, path, screenKey));

    if (isError !== errors[stepIndex]) {
        errors[stepIndex] = isError;
        Store().dispatch(setScreenData(path, errors, screenKey));
    }
};

export const generateLabelIcon = (index, activeStep, isError) => {
    if (isError) {
        return <ErrorOutlineOutlined sx={{ mr: '10px' }} className="steppersvg-error" />;
    }
    if (index < activeStep) {
        return (
            <Box className="steppersvg stepper-done">
                <CheckCircle />
            </Box>
        );
    }
    if (index === activeStep) {
        return (
            <Box className="steppersvg">
                <Circle />
                <Box className="stepper-step">{index}</Box>
            </Box>
        );
    }

    return (
        <Box className="steppersvg">
            <CircleOutlined />
            <Box className="stepper-step stepper-active">{index}</Box>
        </Box>
    );
};

export const getActiveStep = (index, stepsLength, isSuccessScreen, customNext) => {
    if (index < stepsLength - 1)
        return {
            label: customNext?.label || formatMessage(Locale.next),
            mode: stepModes.NEXT,
        };

    if (index === stepsLength - 1)
        return {
            label: formatMessage(Locale.save),
            mode: isSuccessScreen ? stepModes.SUBMIT_WITH_SUCCESS_SCREEN : stepModes.SUBMIT_AND_CLOSE,
        };

    return {
        label: formatMessage(Locale.close),
        mode: stepModes.CLOSE,
    };
};
